// src/pages/Login.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Form, Button, Card, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next'; // Импортируем useTranslation

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const { login, clearError } = useAuth();
    const navigate = useNavigate();
    const { t } = useTranslation(); // Добавляем хук для переводов

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        if (!username || !password) {
            setError(t('auth.fillAllFields'));
            setLoading(false);
            return;
        }

        const result = await login(username, password);

        if (result.success) {
            navigate('/dashboard');
        } else {
            setError(result.message || t('auth.loginError'));
        }

        setLoading(false);
    };

    return (
        <Container className="d-flex justify-content-center align-items-center py-5" style={{ minHeight: 'calc(100vh - 200px)' }}>
            <div className="auth-form-container" style={{ position: 'relative', zIndex: 20 }}>
                <Card className="auth-card" style={{ position: 'relative', zIndex: 25 }}>
                    <Card.Body className="p-4">
                        <div className="text-center mb-4">
                            <div className="brand-logo justify-content-center mb-2">
                                <div className="brand-icon">
                                    <span className="brand-letter">H</span>
                                </div>
                            </div>
                            <h2 className="gradient-text">{t('auth.loginTitle')}</h2>
                            <p className="text-secondary">{t('auth.loginSubtitle')}</p>
                        </div>

                        {error && (
                            <Alert
                                variant="danger"
                                onClose={clearError}
                                dismissible
                            >
                                {error}
                            </Alert>
                        )}

                        <Form onSubmit={handleSubmit} style={{ position: 'relative', zIndex: 30 }}>
                            <Form.Group className="mb-3">
                                <Form.Label className="text-secondary">{t('auth.username')}</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder={t('auth.enterUsername')}
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    className="web3-input"
                                    style={{ position: 'relative', zIndex: 30 }}
                                />
                            </Form.Group>

                            <Form.Group className="mb-4">
                                <Form.Label className="text-secondary">{t('auth.password')}</Form.Label>
                                <Form.Control
                                    type="password"
                                    placeholder={t('auth.enterPassword')}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="web3-input"
                                    style={{ position: 'relative', zIndex: 30 }}
                                />
                            </Form.Group>

                            <Button
                                variant="primary"
                                type="submit"
                                className="w-100 py-2"
                                disabled={loading}
                                style={{ position: 'relative', zIndex: 30 }}
                            >
                                {loading ? (
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className="me-2"
                                        />
                                        {t('auth.loginProcess')}
                                    </>
                                ) : t('auth.loginButton')}
                            </Button>
                        </Form>
                        <div className="text-center mt-4">
                            <p className="text-secondary">
                                {t('auth.noAccount')} <Link to="/register" className="gradient-text">{t('common.register')}</Link>
                            </p>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </Container>
    );
};

export default Login;